import React from "react";
import { useNavigate } from "react-router-dom";
import { MdHome } from "react-icons/md";
import { Container, ErrorCode, ErrorMessage, HomeButton } from "./styled";

const Page404 = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <ErrorMessage>
        A p&aacute;gina que voc&ecirc; procura n&atilde;o existe ou foi movida
      </ErrorMessage>
      <HomeButton onClick={() => navigate("/")}>
        <MdHome size={20} />
        Voltar ao in&iacute;cio
      </HomeButton>
    </Container>
  );
};

export default Page404;
